export const UserRole = {
  USER: 'USER',
  ADMIN: 'ADMIN',
} as const;

export const MemberRole = {
  MEMBER: '일반',
  TEACHER: '강사',
} as const;
